import React, { useEffect } from 'react';
import {
  CohortSampleOperationKey,
  PermissionKey,
  QueryType,
} from '../../../../utils/apollo/graphqlSchema';
import { useFormulaExecute } from '../../../../utils/hooks';
import { useAppDispatch } from '../../../../redux/hooks';
import usePermission from '../../../../utils/hooks/permissionHooks/usePermission';
import PermissionElementWrapper from '../../../PermissionControls/PermissionElementWrapper';
import { clearCachedCohort } from '../../../../redux/slices/cachedEntities';
import ExecuteAction from '../../../../components/Builder/ExecuteReport/ExecuteAction';
import useBuilderSelector from '../../../../redux/selectorHooks/useBuilderSelector';
import useCachedEntitiesSelector from '../../../../redux/selectorHooks/useCachedEntitiesSelector';
import KubitTooltip from '../../../../components/KubitTooltip';

export default () => {
  const dispatch = useAppDispatch();
  const { checkIsPermitted } = usePermission();
  const cachedCohort = useCachedEntitiesSelector('cachedCohort');
  const activeSchemaId = useBuilderSelector('activeSchemaId');
  const builderSampledCohort = useBuilderSelector('builderSampledCohort');
  const { sampleOperation } = builderSampledCohort;

  const isPermittedToExecuteCohort = checkIsPermitted({
    requiredPermissionKeys: [PermissionKey.CohortReportCreate],
    schemaId: activeSchemaId,
  });
  const isCompare =
    sampleOperation && sampleOperation.key === CohortSampleOperationKey.Compare;

  const [executeSample, isSampleValid, isSampleLoading] = useFormulaExecute(
    QueryType.CohortSample,
  );

  useEffect(() => {
    if (cachedCohort && cachedCohort?.isExecuteAfterRedirect) {
      dispatch(clearCachedCohort());
      executeSample();
    }
  }, [cachedCohort, dispatch, executeSample]);

  return (
    <PermissionElementWrapper isPermitted={isPermittedToExecuteCohort}>
      {isCompare ? (
        <KubitTooltip
          disabled={!isPermittedToExecuteCohort}
          content={`Select two cohorts to compare.`}
          placement="top"
        >
          <ExecuteAction
            onClick={executeSample}
            disabled={isSampleLoading || !isPermittedToExecuteCohort}
            isGreyedOut={!isSampleValid}
            label={'Compare'}
            trackContext="cohorts"
            trackAction="compare"
          />
        </KubitTooltip>
      ) : (
        <KubitTooltip
          disabled={!isPermittedToExecuteCohort}
          content={
            `Generate a list of 'Subjects' that meet the above cohort criteria, ` +
            `return up to 5,000 rows of data.`
          }
          placement="top"
        >
          <ExecuteAction
            onClick={executeSample}
            disabled={isSampleLoading || !isPermittedToExecuteCohort}
            isGreyedOut={!isSampleValid}
            label={'Inspect'}
            trackContext="cohorts"
            trackAction="inspect"
          />
        </KubitTooltip>
      )}
    </PermissionElementWrapper>
  );
};
